import { render, staticRenderFns } from "./DealerTerminatedList.vue?vue&type=template&id=f0b8a35c&"
import script from "./DealerTerminatedList.vue?vue&type=script&lang=js&"
export * from "./DealerTerminatedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports